import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/css/style.css';
import App from './App';
import { ParallaxProvider } from 'react-scroll-parallax';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';

ReactDOM.render(
  <React.StrictMode>
    <ParallaxProvider>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ParallaxProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
